import { render, staticRenderFns } from "./MenuLinkItem.vue?vue&type=template&id=315e388f"
import script from "./MenuLinkItem.vue?vue&type=script&lang=js"
export * from "./MenuLinkItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports